export default "__VITE_ASSET__2CNhgll1__"